.PreviewEmptyState {
  display: grid;
  justify-items: center;
  overflow: hidden;
  row-gap: 2em;
  text-align: center;
  white-space: pre-line;

  > svg {
    width: 120px;
    height: 120px;
  }
}
